import { AccountCircle, AccountCircleOutlined } from '@mui/icons-material';

import { useTranslate } from '../../../../hooks/useTranslate';
import { useSembonusUser } from '../../../../providers/UserProvider';
import type { AuthProps } from '../../Header.types';
import { Button, FullName, Initials, Link } from './User.styles';

export const User = ({ onAuthClick }: AuthProps) => {
  const { t } = useTranslate();
  const { isCheckingLoggedInState, isLoggedIn, userInfo } = useSembonusUser();

  if (isCheckingLoggedInState) {
    return null;
  }

  if (isLoggedIn) {
    const initials = userInfo?.member.firstName
      .slice(0, 1)
      .concat(userInfo?.member.lastName.slice(0, 1))
      .toUpperCase();

    return (
      <Link href="/travel/ob/members/profile">
        <AccountCircle />

        <Initials>{initials}</Initials>

        <FullName>
          {userInfo?.member.firstName} {userInfo?.member.lastName}
        </FullName>
      </Link>
    );
  }

  return (
    <Button type="button" onClick={() => onAuthClick('header')}>
      <AccountCircleOutlined />

      {t('explore.header.signIn')}
    </Button>
  );
};
